import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import interact from 'interactjs';

export const Marking = ({
  children,
  draggable = false,
  dropzone = false,
  resizable = false,
  draggableOptions = {},
  dropzoneOptions = {},
  resizableOptions = {},
}) => {
  const nodeRef = useRef(null);

  useEffect(() => {
    const node = nodeRef.current;

    if (!node) {
      return;
    }

    const interactable = interact(node);

    if (draggable) {
      interactable.draggable(draggableOptions);
    }

    if (dropzone) {
      interactable.dropzone(dropzoneOptions);
    }

    if (resizable) {
      interactable.resizable(resizableOptions);
    }

    return () => {
      interactable.unset();
    };
  }, [draggable, dropzone, resizable, draggableOptions, dropzoneOptions, resizableOptions]);

  return <>{React.cloneElement(children, { ref: nodeRef, draggable: false })}</>;
};

Marking.propTypes = {
  children: PropTypes.node.isRequired,
  draggable: PropTypes.bool,
  draggableOptions: PropTypes.object,
  dropzone: PropTypes.bool,
  dropzoneOptions: PropTypes.object,
  resizable: PropTypes.bool,
  resizableOptions: PropTypes.object,
};